import { ActionsUnion, createAction } from "../definitions";
import { SystemHosLogActionTypes, UserHosLogActionTypes, HistoricalDayActionTypes } from "./types";
import DutyStatusLog from "../../model/DutyStatusLog";
import { IDailyOdometer } from "../../model/DutyStatusLogs";
import { type IViolation } from "hos-tools";

export interface IHosLogPayload {
    userId: string;
    logs: IIdDictionary<DutyStatusLog>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const HosLogActions = {
    setUserHosLogs: (payload: IHosLogPayload) => createAction(UserHosLogActionTypes.SET_USER_HOS_LOGS, payload),
    setSystemHosLogs: (payload: IHosLogPayload) => createAction(SystemHosLogActionTypes.SET_SYSTEM_HOS_LOGS, payload),
    /**
     * Used to clear User HOS Logs from storage
     * @param keepUsers Optional array of {@link IUser}s for which UserHosLogs should be kept.
     */
    clearUserHosLogs: (keepUsers?: IUser[]) => createAction(UserHosLogActionTypes.CLEAR_USER_HOS_LOGS, keepUsers),
    /**
     * Used to clear System HOS Logs from storage
     * @param keepUsers Optional array of {@link IUser}s for which SystemHosLogs should be kept.
     */
    clearSystemHosLogs: (keepUsers?: IUser[]) => createAction(SystemHosLogActionTypes.CLEAR_SYSTEM_HOS_LOGS, keepUsers)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type HosLogActions = ActionsUnion<typeof HosLogActions>;

export interface ITrackHistoricalDayPayload {
    userId: string;
    dateKey: string;
    loadedAt: number;
    hosLogs: DutyStatusLog[];
    systemLogs: DutyStatusLog[];
    violations: IViolation[];
    odometer?: IDailyOdometer;
}

export interface IUntrackHistoricalDayPayload {
    userId: string;
    dateKey: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const HistoricalDayActions = {
    trackHistoricalDay: (payload: ITrackHistoricalDayPayload) =>
        createAction(HistoricalDayActionTypes.TRACK_HISTORICAL_DAY, payload),
    untrackHistoricalDay: (payload: IUntrackHistoricalDayPayload) =>
        createAction(HistoricalDayActionTypes.UNTRACK_HISTORICAL_DAY, payload),
    clearTrackedDays: (keepUsers?: IUser[]) => createAction(HistoricalDayActionTypes.CLEAR_TRACKED_DAYS, keepUsers),
    /** Drops every cached historical day for one user, leaving other users' (e.g. co-drivers') days alone. */
    clearUserTrackedDays: (userId: string) => createAction(HistoricalDayActionTypes.CLEAR_USER_TRACKED_DAYS, userId)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type HistoricalDayActions = ActionsUnion<typeof HistoricalDayActions>;